<template>
    <div class="modal fade in" data-backdrop="static" data-keyboard="false" id="ModalAssinar">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <p class="modal-title"><i class="fa fa-pencil"></i> Assinar documento {{file.arquivo_nome}}</p>
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                </div>
                <div class="modal-body">
                     <strong>
                        <required /> Arquivo que será assinado: </strong>
                    {{file.arquivo_nome}}.{{file.arquivo_extensao}}
                    <div class="row">
                        <div class="col-md-12">
                            <div class="callout callout-warning">
                                <h6><b><i class="fa fa-exclamation-triangle"></i></b>
                                    O documento será assinado SEM uso do certificado digital próprio.</h6>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" data-dismiss="modal" class="btn btn-default float-left"><i
                            class="fa fa-times"></i>
                        {{ $t('words.cancel')}}</button>
                    <button type="button" id="signButton" :disabled="loading" @click="sign()"
                        class="btn btn-success float-right"><i class="fa fa-check"></i>
                        Assinar <i v-show="loading" class="fa fa-circle-o-notch fa-spin"></i></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: false,
                tokenTipo: 'E',
                request: {
                    id: null,
                },
                file: {}
            }
        },
        methods: {
            sign() {
                this.loading = true;
                this.request.id = this.file.id;
                this.$store.dispatch('signWithoutCert', this.request).then(response => {
                    toastr({
                        title: response.message,
                        icon: response.status
                    });
                    $('#ModalAssinar').modal('toggle');
                    this.$store.commit('REFRESH_USER_FILES', Math.random().toString(36).substr(2, 5));
                    this.$store.dispatch('getUserData');
                }).catch(error => {
                    toastr({
                        title: error.message,
                        icon: error.status
                    });
                }).finally(() => {
                    this.loading = false;
                });
            }
        }
    }
</script>